import React, { Component } from 'react'
import shortid from 'shortid'
import { withStyles } from '@material-ui/styles'
import { ClientForm } from './../forms'
import { Dashboard } from './../layouts'
import axios from './../plugins/axios'

const styles = theme => ({
    //
})

class ClientUpdate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: 'Clients',
            key: shortid.generate(),
            name: '',
            url: '',
            image: ''
        }
    }

    componentWillMount = () => {
        this.fetchData()
    }

    fetchData = async () => {
        const { match } = this.props
        const { id } = match.params

        try {
            const { data } = await axios.get(`/clients/${id}`, { progress: true})

            this.setState({
                key: shortid.generate(),
                name: data.name,
                url: data.url,
                image: data.image
            })
        } catch (e) {
            //
        }
    }

    render() {
        const {
            title,
            key,
            name,
            url,
            image
        } = this.state
        const { match } = this.props
        const { id } = match.params
        return (
            <Dashboard title={title}>
                <ClientForm
                    key={key}
                    path={`clients/${id}`}
                    method="put"
                    name={name}
                    url={url}
                    image={image}
                    message="Амжилттай шинэчлэгдлээ"
                />
            </Dashboard>
        )
    }
}

export default withStyles(styles)(ClientUpdate)
